import { render, staticRenderFns } from "./ProfilePasswordForm.vue?vue&type=template&id=289701fc&"
import script from "./ProfilePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ProfilePasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports